import { render, staticRenderFns } from "./AppointmentsList.vue?vue&type=template&id=34492703&scoped=true&"
import script from "./AppointmentsList.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsList.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsList.vue?vue&type=style&index=0&id=34492703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34492703",
  null
  
)

export default component.exports